import { create } from "zustand";

interface TranscriptionState {
  activeTranscriberId: string | null;
  setActiveTranscriber: (id: string | null) => void;
  isActive: (id: string) => boolean;
  stopAllTranscription: () => void;
  // True while the AudioRecorder modal owns the session. Section
  // textareas read this and skip live writes so the modal stays isolated
  // — the only thing that should populate the section content is the
  // /transcription/summarize call fired on Done.
  isModalSession: boolean;
  setModalSession: (active: boolean) => void;
}

export const useTranscription = create<TranscriptionState>((set, get) => ({
  activeTranscriberId: null,
  isModalSession: false,

  setActiveTranscriber: (id) => {
    set({ activeTranscriberId: id });
  },

  isActive: (id) => {
    return get().activeTranscriberId === id;
  },

  stopAllTranscription: () => {
    set({ activeTranscriberId: null, isModalSession: false });
  },

  setModalSession: (active) => {
    set({ isModalSession: active });
  },
}));
